import React, { useEffect, useState } from "react";
import { AwardCard } from "../components/AwardCard";
import { generateClient } from "aws-amplify/api";
import { listSlumSoccerAwards } from "../graphql/queries";

const client = generateClient();

const getAwardDate = (award) => {
  try {
    // Check if ef1 exists and is a string before parsing
    const ef1 = typeof award.ef1 === 'string' 
      ? JSON.parse(award.ef1) 
      : award.ef1;
    
    // Parse date, handling potential different formats
    return ef1?.date ? new Date(ef1.date) : new Date(0);
  } catch (error) {
    console.error(`Error parsing date for project:`, award);
    return new Date(0);
  }
};

export default function Awards(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  },[]);

  useEffect(() => {
    window.scrollTo(0, 0);
  },);

  const fetchData = async () => {
    try {
      let pendingData = await client.graphql({
        query: listSlumSoccerAwards,
      });

      const rawAwards = pendingData["data"]["listSlumSoccerAwards"].items;

      const sortedAwards = rawAwards.sort((a, b) => {

        // Compare dates
        const dateA = getAwardDate(a);
        const dateB = getAwardDate(b);

        return dateB - dateA; // Newest first
      });

      setData(sortedAwards);
    } catch (error) {
      console.error("Error fetching awards:", error);
    }
  };

  return (
    <>
      <section className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 animate__animated animate__bounceInUp">
        <div className="container mx-auto px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-orange-500 relative inline-block -mt-5">
              Our Awards
              <div className="h-1 w-full bg-orange-500 mt-2"></div>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {data.map((award) => (
              <AwardCard key={award.awardId} award={award} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
